import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ReplyIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M9.826 8.241V3.77L2 11.595l7.826 7.826v-4.584c5.59 0 9.502 1.79 12.297 5.702-1.117-5.59-4.471-11.18-12.297-12.298z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Reply.js.map